import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    autoComplete: {
        width: '100%',
    },
}));
